<template>
  <div class="search_box">
    <a-form layout="inline" :model="formValue">
      <template v-for="item in formItems" :key="item">
        <a-form-item :label="item.label" v-if="item.isShow ?? true">
          <form-item :item="item" @change="onChange" />
        </a-form-item>
      </template>
      <a-form-item v-if="1">
        <a-space>
          <!-- 插槽容器，用于检测内容 -->
          <!-- <div v-show="false" ref="slotContainer">
            <slot name="action"></slot>
          </div> -->

          <!-- 仅当插槽有内容时显示 -->
          <!-- <div v-if="hasActionContent" class="action-slot-wrapper"> -->
          <slot name="action"></slot>
          <!-- </div> -->
          <a-button type="primary" @click="onSearch" v-if="isShowSearch">搜索</a-button>
          <a-button type="primary" @click="onReset" ghost v-if="isShowReset">重置</a-button>
        </a-space>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, computed, onMounted, onUpdated, watch, useSlots } from 'vue';
import { formItem } from '@/component';

const { proxy } = getCurrentInstance();

const emits = defineEmits(['onSubmit', 'loadData']);

const props = defineProps({
  formItems: { type: Array, default: [] },
  isShowSearch: { type: Boolean, default: true },
  isShowReset: { type: Boolean, default: true },
});

// 使用 Vue3 的 useSlots() 获取插槽信息
const slots = useSlots();

// 创建引用用于检测 DOM 内容
const slotContainer = ref(null);

// 检测插槽是否有内容的状态
const hasSlotContent = ref(false);

// 检测实际显示的内容（过滤空白等）
const hasActionContent = ref(false);

// 计算属性 - 判断整个表单项是否应该显示
const shouldShowActions = computed(() => {
  return hasActionContent.value || props.isShowSearch || props.isShowReset;
});

// 检查插槽是否有实际内容
const checkSlotContent = () => {
  // 第一步：使用 Vue3 插槽 API 检测
  if (slots.action && slots.action().length > 0) {
    hasSlotContent.value = true;
  } else {
    hasSlotContent.value = false;
    hasActionContent.value = false;
  }
};

// 使用 MutationObserver 监听插槽内容变化
let observer = null;

onMounted(() => {
  checkSlotContent();

  // 配置 MutationObserver 监听插槽内容
  const config = { childList: true, subtree: true, characterData: true };

  observer = new MutationObserver((mutations) => {
    const container = slotContainer.value;
    if (!container) return;

    // 检测是否有实际内容（过滤空白字符）
    hasActionContent.value = container.children.length > 0 && container.textContent.trim() !== '';
  });

  if (slotContainer.value) {
    observer.observe(slotContainer.value, config);
  }
});

// 监听插槽变化
watch(
  () => slots.action,
  () => {
    checkSlotContent();
  },
  { deep: true },
);

const getPlaceholder = ({ type, label }) => {
  return `请${['select', 'cascade'].includes(type) ? '选择' : '输入'}${label}`;
};

const formValue = ref({}),
  onSetForm = () => {
    const obj = {};
    props.formItems.forEach((item) => {
      const { value, type, isShow } = item;
      if ((item.hasOwnProperty('isShow') && isShow) || !item.hasOwnProperty('isShow')) {
        if (['input'].includes(type)) obj[value] = '';
        else if (['select', 'cascade'].includes(type)) obj[value] = [];
      }
    });
    formValue.value = obj;
  };

const onChange = (e) => {
  // props.formItems.forEach((item) => {
  formValue.value[e.key] = e.value;
  // });
  emits('change', e);
};

const onSearch = () => {
    emits('onSubmit', formValue.value);
  },
  onReset = () => {
    onSetForm();
    emits('onSubmit', formValue.value);
  };
</script>

<style lang="less" scoped>
.search_box {
  width: 100%;
  height: 80px;
  background: #fff;
  border-radius: 10px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  :deep(.ant-form-item .ant-form-item-control-input-content) {
    min-width: 200px;
  }
}
.action-slot-wrapper {
  display: flex;
  gap: 8px;
}
</style>
